import { render } from "./RequestsTable.vue?vue&type=template&id=b9390ef4&scoped=true"
import script from "./RequestsTable.vue?vue&type=script&lang=js"
export * from "./RequestsTable.vue?vue&type=script&lang=js"

import "./RequestsTable.vue?vue&type=style&index=0&id=b9390ef4&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9390ef4"]])

export default __exports__